import { useMemo } from 'react';
import { Collapse } from 'antd';

import ItemTypeIcon from 'components/common/item-type-icon';
import { classnames } from 'lib/classnames';
import { dataFormat } from 'lib/fields';
import useI18n from 'lib/hooks/useI18n';
import { FieldValue } from 'lib/types/field';

import Status from '../../../item-move/Status';

import styles from './index.module.less';

const cx = classnames(styles);
interface ChangeDataProps {
  items: any[];
  data: Record<string, FieldValue>;
}

const ChangeView: React.FC<ChangeDataProps> = ({ data, items }) => {
  const { t } = useI18n();

  const itemData = useMemo(() => {
    return items.map(itemDetail => ({
      key: itemDetail.objectId,
      type: 'view',
      label: (
        <div className={cx('page-header')}>
          <div className={cx('header-content')}>
            <ItemTypeIcon
              name={itemDetail.itemType.name}
              icon={itemDetail.itemType.icon}
              className={cx('item-type-icon')}
            />
            {itemDetail.key}
            <span className={cx('page-header-title')}>{itemDetail.name}</span>
          </div>
        </div>
      ),
      children: (
        <div className={cx('view-wrap')}>
          <div className={cx('view-header')}>
            <span>{t('pages.itemMove.fieldName')}</span>
            <span>{t('pages.itemMove.current.field')}</span>
            <span>{t('pages.itemMove.next.field')}</span>
          </div>
          <div className={cx('view-content')}>
            {data[itemDetail.id].map(item => {
              if (item.type === 'itemType') {
                return (
                  <div className={cx('view-item')} key={`${item.name}-${item.type}`}>
                    <span className={cx('column-text')}>{item.name}</span>
                    <span className={cx('column-text')}>
                      <ItemTypeIcon name={item.before.data} icon={item.before.icon} className={cx('item-type-icon')} />
                      {item.before.data}
                    </span>
                    <span className={cx('column-text')}>
                      <ItemTypeIcon
                        name={item.after.data}
                        icon={item.after.icon || ''}
                        className={cx('item-type-icon')}
                      />
                      {item.after.data}
                    </span>
                  </div>
                );
              }
              if (item.type === 'status') {
                return (
                  <div className={cx('view-item')} key={`${item.name}-${item.type}`}>
                    <span className={cx('column-text')}>{item.name}</span>
                    <span className={cx('column-text')}>
                      <Status name={item.before.name} type={item.before.type} />
                    </span>
                    <span className={cx('column-text')}>
                      <Status name={item.after.name} type={item.after.type} />
                    </span>
                  </div>
                );
              }

              return (
                <div key={item.name} className={cx('view-item')}>
                  <span className={cx('column-text')}>{item.name}</span>
                  <span className={cx('column-text')}>{dataFormat(item.before)}</span>
                  <span className={cx('column-text')}>{dataFormat(item.after)}</span>
                </div>
              );
            })}
          </div>
        </div>
      ),
    }));
  }, [data, items, t]);

  return (
    <div className={cx('field-wrap')}>
      <Collapse defaultActiveKey={items.map(item => item.objectId)} items={itemData} />
    </div>
  );
};

export default ChangeView;
